module.exports = __webpack_public_path__ + "img/grab.5588a6a4.png";